module.exports = __webpack_public_path__ + "img/undraw_website_builder_bxki.880a5296.png";